import { render, staticRenderFns } from "./AboutUsTimeLineItem.vue?vue&type=template&id=61db13f6&scoped=true&"
import script from "./AboutUsTimeLineItem.vue?vue&type=script&lang=js&"
export * from "./AboutUsTimeLineItem.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsTimeLineItem.vue?vue&type=style&index=0&id=61db13f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db13f6",
  null
  
)

export default component.exports